/* ============================================================
   MeAyurv PDP — rewards-safe add to cart (cross-sell Q + FBT).
   Mirrors Sense's native add flow: /cart/add.js -> cart UI
   renderContents() -> publish(cartUpdate). The cart-rewards bar
   already subscribes to cartUpdate, so it reconciles automatically
   — we never touch the rewards code. Init-guarded + delegated.
   ============================================================ */
(function () {
  if (window.__meayurvPdpCartInit) return;
  window.__meayurvPdpCartInit = true;

  function cartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function sectionsFor(ui) {
    try {
      if (ui && typeof ui.getSectionsToRender === 'function') {
        return ui.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addItems(items, btn) {
    var ui = cartUI();
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    var body = { items: items };
    if (ui) { body.sections = sectionsFor(ui); body.sections_url = window.location.pathname; }

    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }

    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { throw res; } // Shopify add error
        if (ui && typeof ui.renderContents === 'function') ui.renderContents(res);
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'meayurv-pdp', cartData: res });
          }
        } catch (e) {}
        if (ui && typeof ui.open === 'function') ui.open();
        return res;
      })
      .catch(function (err) { console.warn('[MeAyurv PDP] add failed', err); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      });
  }

  function rowsOf(fbt) {
    return Array.prototype.slice.call(fbt.querySelectorAll('[data-mpdp-fbt-item]'));
  }
  function isOn(row) {
    if (row.hasAttribute('data-locked')) return true;
    var cb = row.querySelector('input[type="checkbox"]');
    return cb ? cb.checked : true;
  }
  function recompute(fbt) {
    var total = 0, count = 0;
    rowsOf(fbt).forEach(function (row) {
      var on = isOn(row);
      row.classList.toggle('is-off', !on);
      var vid = row.getAttribute('data-variant');
      var tile = fbt.querySelector('[data-mpdp-fbt-tile="' + vid + '"]');
      if (tile) tile.classList.toggle('is-off', !on);
      if (on) { total += Number(row.getAttribute('data-price')) || 0; count += 1; }
    });
    var tEl = fbt.querySelector('[data-mpdp-fbt-total]');
    if (tEl) tEl.textContent = '₹' + Math.round(total / 100).toLocaleString('en-IN');
    var cEl = fbt.querySelector('[data-mpdp-fbt-count]');
    if (cEl) cEl.textContent = count;
  }

  // Single add (cross-sell card) + bundle add (FBT)
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-mpdp-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-mpdp-add');
      if (id) addItems([{ id: Number(id), quantity: 1 }], add);
      return;
    }
    var bundle = e.target.closest('[data-mpdp-add-bundle]');
    if (bundle) {
      e.preventDefault();
      var fbt = bundle.closest('.mpdp-fbt');
      if (!fbt) return;
      var items = [];
      rowsOf(fbt).forEach(function (row) {
        if (isOn(row)) items.push({ id: Number(row.getAttribute('data-variant')), quantity: 1 });
      });
      if (items.length) addItems(items, bundle);
    }
  });

  // FBT checkbox -> recompute total + count
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('.mpdp-fbt input[type="checkbox"]');
    if (cb) recompute(cb.closest('.mpdp-fbt'));
  });

  // Initial totals
  function init() { document.querySelectorAll('.mpdp-fbt').forEach(recompute); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
